module.exports = __webpack_public_path__ + "static/media/3.223412d4.jpg";